import { Method } from "../../data/DataUtils.js";
import * as DataUtils from "../../data/DataUtils.js";
import * as DTOs from "../DTOs/BoletinesPersonaDTOs.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
  "personas/" + idPadre + "/boletines_afa/" + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject("personas/" + idPadre + "/boletines_afa/" + idItem);
}

export const GetListaItems = async (idPadre) => {
  // Filter boletines to type J
  return DataUtils.FetchLista("personas/" + idPadre + "/boletines_afa?tipoBoletin=J");
}

export const PostItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.POST,
  "personas/" + idPadre + "/boletines_afa",
    DTOs.saveItem(datosItem)
  );
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataUtils.SaveObject(
    Method.PUT,
  "personas/" + idPadre + "/boletines_afa/" + datosItem.id,
    DTOs.saveItem(datosItem)
  );
};
